import { render, staticRenderFns } from "./ClubRosterRatings.vue?vue&type=template&id=54f42690&scoped=true"
import script from "./ClubRosterRatings.vue?vue&type=script&lang=js"
export * from "./ClubRosterRatings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f42690",
  null
  
)

export default component.exports